/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Admin_Tickets_Latest_Reply_ColInputs */

const en_admin_tickets_latest_reply_col = /** @type {(inputs: Admin_Tickets_Latest_Reply_ColInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Latest Reply`)
};

const zh_admin_tickets_latest_reply_col = /** @type {(inputs: Admin_Tickets_Latest_Reply_ColInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`最新回复`)
};

/**
* | output |
* | --- |
* | "Latest Reply" |
*
* @param {Admin_Tickets_Latest_Reply_ColInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const admin_tickets_latest_reply_col = /** @type {((inputs?: Admin_Tickets_Latest_Reply_ColInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Admin_Tickets_Latest_Reply_ColInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_admin_tickets_latest_reply_col(inputs)
	return zh_admin_tickets_latest_reply_col(inputs)
});
export { admin_tickets_latest_reply_col as "admin.tickets.latest_reply_col" }